import Http from '../Http';

export class UnidadTransporteService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const params = new URLSearchParams();
    params.set('p', page.toString());
    params.set('l', limit.toString());
    
    if (Object.keys(filters).length) {
      params.set('q', JSON.stringify(filters));
    }
    if (orderBy) {
      params.set('orderBy', orderBy);
      params.set('order', order);
    }

    try {
      const res = await Http.get(`unidad-transporte/filter?${params.toString()}`);
      return res.data.rows || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  static async eliminar(row: any) {
    try {
      const res = await Http.post(`unidad-transporte/delete`, row);
      return !res.error;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  static async obtenerPorId(id: string | number) {
    try {
      const res = await Http.get(`unidad-transporte/one/${id}`);
      return res.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async obtenerOpcionesForm(params: Record<string, any> = {}) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') {
        searchParams.set(k, String(v));
      }
    });
    try {
      const queryStr = searchParams.toString();
      const url = queryStr ? `unidad-transporte/form?${queryStr}` : `unidad-transporte/form`;
      const res = await Http.get(url);
      return res.data;
    } catch (e) {
      console.error(e);
      return {};
    }
  }

  static async guardar(data: Record<string, any>) {
    try {
      const isEdit = Boolean(data.id_unidad_transporte || data.id);
      const url = isEdit ? 'unidad-transporte/edit' : 'unidad-transporte/save';
      const payload = {
        ...data,
        id_unidad_transporte: data.id_unidad_transporte || data.id,
      };
      const res = await Http.post(url, payload);
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: (e as any)?.message || 'Error al guardar la unidad de transporte' };
    }
  }

  static async generarPassword(id_unidad_transporte: string | number) {
    try {
      const res = await Http.post('unidad-transporte/temporal-password', { id_unidad_transporte });
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: (e as any)?.message || 'Error al generar contraseña temporal' };
    }
  }

  static async toggleActivo(id_unidad_transporte: string | number) {
    try {
      const res = await Http.post('unidad-transporte/toggle-active', { id_unidad_transporte });
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: (e as any)?.message || 'Error al cambiar estado del chofer' };
    }
  }

  static async buscarCodigoPostal(search: string) {
    try {
      const res = await Http.post('search/codigo-postal', { search });
      return res.data || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}
